import { render, staticRenderFns } from "./ContactsPicker.vue?vue&type=template&id=5069e866&"
import script from "./ContactsPicker.vue?vue&type=script&lang=js&"
export * from "./ContactsPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports